// 共通ユーティリティ

export const formatVersionDt = (input: any, tz: string = 'Asia/Tokyo'): string => {
  if (input == null || input === '') return '-';
  try {
    let d: Date;
    if (input instanceof Date) {
      d = input;
    } else if (typeof input === 'number') {
      d = new Date(input);
    } else {
      let str = String(input).trim();
      // タイムゾーン指定が無ければ UTC とみなす（Z を付与）
      if (!/[zZ]|([+-]\d{2}:\d{2})$/.test(str)) {
        str += 'Z';
      }
      d = new Date(str);
    }
    if (Number.isNaN(d.getTime())) return '-';
    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: tz,
    }).format(d);
  } catch {
    return '-';
  }
};

/**
 * 日付を "y/m/d" 形式にフォーマット（ゼロ埋めなし, 例: 2025/12/1）
 * - 文字列 "YYYY-MM-DD" / "YYYY/MM/DD" / "YYYY.MM.DD" を安全に解釈（タイムゾーンずれ回避）
 * - ISO 8601 などの日時文字列は tz のタイムゾーンで日付抽出
 * - 無効値は空文字を返す
 */
export const formatYmd = (input: any, tz: string = 'Asia/Tokyo'): string => {
  if (input == null || input === '') return '';
  try {
    let d: Date | null = null;

    if (input instanceof Date) {
      d = input;
    } else if (typeof input === 'number') {
      d = new Date(input);
    } else {
      const s = String(input).trim();

      // 単純な日付 "YYYY[-/.]M[-/.]D" はローカル日付として組み立て（00:00固定）
      const m = s.match(/^(\d{4})[-\/\.](\d{1,2})[-\/\.](\d{1,2})/);
      if (m) {
        const y = Number(m[1]), mo = Number(m[2]), da = Number(m[3]);
        if (Number.isFinite(y) && Number.isFinite(mo) && Number.isFinite(da)) {
          d = new Date(y, mo - 1, da);
        }
      }

      // それ以外は Date で解釈（タイムゾーン明示なければ UTC とみなす）
      if (!d) {
        let str = s;
        if (!/[zZ]|([+-]\d{2}:\d{2})$/.test(str) && /T/.test(str)) {
          str += 'Z';
        }
        const tmp = new Date(str);
        if (!Number.isNaN(tmp.getTime())) d = tmp;
      }
    }

    if (!d || Number.isNaN(d.getTime())) return '';

    // tz の日付を "y/m/d"（ゼロ埋めなし）で返す
    return new Intl.DateTimeFormat('ja-JP', {
      timeZone: tz,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).format(d);
  } catch {
    return '';
  }
};